export const phoneMask = [
  "+",
  "3",
  "8",
  "(",
  "0",
  /[1-9]/,
  /\d/,
  ")",
  /\d/,
  /\d/,
  /\d/,
  "-",
  /\d/,
  /\d/,
  "-",
  /\d/,
  /\d/,
];

export const formatPhoneValue = (value: string) => {
  if (!value) return "";
  const onlyNumbers = value.replace(/\D/g, "");
  const mask = "(XXX) XXX-XX-XX-XX";
  let formatted = "";
  let numberIndex = 0;

  for (const char of mask) {
    if (char === "X") {
      if (numberIndex < onlyNumbers.length) {
        formatted += onlyNumbers[numberIndex++];
      } else {
        break;
      }
    } else {
      formatted += char;
    }
  }

  return formatted;
};
